const maximum = 31

export default class DateRangeCalculator {
  /**
   * Create new date range calculator
   *
   * @param {Object} moment
   */
  constructor (moment) {
    this.moment = moment
  }

  getHourRange (date) {
    return this.getRange(this.moment(date).startOf('day'), this.moment(date).endOf('day'), 'hours')
  }

  getDays (date, amount) {
    return this.getDayRange(date, this.moment(date).add(amount, 'day'))
  }

  getDayRange (startDate, endDate) {
    return this.getRange(this.moment(startDate).startOf('day'), this.moment(endDate).endOf('day'), 'days')
  }

  getWeek (date) {
    return this.getDayRange(this.moment(date).startOf('week'), this.moment(date).endOf('week'))
  }

  getWeeks (date, amount) {
    return this.getWeekRange(date, this.moment(date).startOf('week').add(amount, 'week'))
  }

  getWeekRange (startDate, endDate) {
    return this.getRange(this.moment(startDate).startOf('week'), this.moment(endDate).endOf('week'), 'weeks')
  }

  getMonth (date) {
    return this.getDayRange(this.moment(date).startOf('month'), this.moment(date).endOf('month'))
  }

  getMonths (date, amount) {
    return this.getMonthRange(date, this.moment(date).startOf('month').add(amount, 'month'))
  }

  getMonthRange (startDate, endDate) {
    return this.getRange(this.moment(startDate).startOf('month'), this.moment(endDate).endOf('month'), 'months')
  }

  getYear (date) {
    return this.getMonthRange(this.moment(date).startOf('year'), this.moment(date).endOf('year'))
  }

  getYears (date, amount) {
    return this.getYearRange(date, this.moment(date).startOf('year').add(amount, 'year'))
  }

  getYearRange (startDate, endDate) {
    return this.getRange(this.moment(startDate).startOf('year'), this.moment(endDate).endOf('year'), 'years')
  }

  getRange (startDate, endDate, interval) {
    let range = this.moment.range(startDate, endDate).snapTo(interval)
    const step = this.calculateStep(startDate, endDate, interval)

    return { startDate, endDate, range: Array.from(range.by(interval, { step })).map(date => ({ startDate: this.moment(date), endDate: this.moment(date).add((step - 1), interval).endOf(interval) })) }
  }

  calculateStep (startDate, endDate, interval) {
    let step = 1

    const length = (endDate.diff(startDate, interval) + 1)

    while ((length / step) > maximum) {
      step++
    }

    return step
  }
}
